import {
  LayoutDashboard,
  Star,
  MessageSquare,
  Bell,
  Settings,
  CreditCard,
  ChevronDown,
  ShieldCheck,
} from "lucide-react";
import { NavLink } from "react-router-dom";

const navItems = [
  {
    name: "Overview",
    icon: LayoutDashboard,
    path: "/overview-demo",
  },
  {
    name: "Reviews",
    icon: Star,
    path: "/reviews-demo",
  },
  {
    name: "Responses",
    icon: MessageSquare,
    path: "/responses-demo",
  },
  {
    name: "Notifications",
    icon: Bell,
    path: "/notifications-demo",
  },
  {
    name: "Settings",
    icon: Settings,
    path: "/settings-demo",
  },
  {
    name: "Billing",
    icon: CreditCard,
    path: "/billing-demo",
  },
];

export default function Sidebar({ onNavigate }) {
  return (
    <aside className="sticky top-0 h-screen w-[280px] shrink-0 bg-gradient-to-b from-slate-950 to-blue-950 text-white flex flex-col border-r border-white/10">
      {/* Logo */}
      <div className="px-6 py-6">
        <div className="mb-4">
          <span className="inline-flex items-center gap-2 rounded-full bg-indigo-500/15 border border-indigo-400/20 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-indigo-200">
            <span className="h-2 w-2 rounded-full bg-indigo-400 animate-pulse" />
            Demo Dashboard
          </span>
        </div>

        <div className="flex items-center gap-3">
          <div className="h-12 w-12 rounded-2xl flex items-center justify-center bg-white/10">
            <ShieldCheck size={24} />
          </div>

          <div>
            <h1 className="font-heading text-2xl font-bold tracking-tight">
              RevUShield
            </h1>
          </div>
        </div>
      </div>

      {/* Business Selector */}
      <div className="px-4 py-5">
        <button className="w-full bg-white/10 hover:bg-white/15 transition rounded-2xl p-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="h-12 w-12 rounded-xl bg-slate-700 flex items-center justify-center text-sm font-semibold">
              JC
            </div>

            <div className="text-left">
              <p className="font-semibold text-sm">Joe's Coffee Shop</p>

              <p className="text-xs text-slate-300">Columbus, OH</p>
            </div>
          </div>

          <ChevronDown size={18} />
        </button>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 space-y-2 overflow-y-auto">
        {navItems.map((item) => {
          const Icon = item.icon;

          return (
            <NavLink
              key={item.name}
              to={item.path}
              onClick={onNavigate}
              className={({ isActive }) =>
                `
                  w-full flex items-center gap-3 px-4 py-3 rounded-xl transition
                  ${
                    isActive
                      ? "bg-indigo-600 text-white shadow-lg shadow-indigo-600/20"
                      : "text-slate-300 hover:bg-white/10 hover:text-white"
                  }
                `
              }
            >
              <Icon size={20} />

              <span className="font-medium text-sm">{item.name}</span>
            </NavLink>
          );
        })}
      </nav>

      {/* User Profile */}
      <div className="p-4 border-t border-white/10">
        <div className="bg-white/5 rounded-2xl p-3 flex items-center gap-3">
          <div className="h-12 w-12 rounded-full bg-slate-500 flex items-center justify-center font-bold">
            JS
          </div>

          <div className="flex-1">
            <p className="font-medium text-sm">John Smith</p>

            <p className="text-xs text-slate-400">john@joescoffee.com</p>
          </div>
        </div>
      </div>
    </aside>
  );
}
